<template>
  <div style="margin: 0 auto; width: 10px;">
    <div class="medium mb-5 mt-5" :class="getColor"></div>
  </div>
</template>
<script>
export default {
  name: 'spinner',
  props: ['color'],
  computed: {
    getColor () {
      return this.color
    }
  }
}
</script>
